var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.billingOnboardingDetailsLoaded)?_c('v-container',{staticClass:"layout-container"},[(_vm.showPaymentStep)?_c('Billing',{attrs:{"has-payment-provider":_vm.hasPaymentProvider},on:{"completed":_vm.handleBillingCompleted}}):_c('onboarding')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }